import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import parse from "html-react-parser";

/**
 * Text :
 *  - Component that display the description with highlighthing
 */
export function Text(props) {
  const { t: translate } = useTranslation(["translation"]);

  let translatedDescription = translate(props.description);

  const insideHighlightRange = (highlightItem) =>
    props.percentage >= highlightItem.minRange &&
    props.percentage <= highlightItem.maxRange;

  const includeHighlights = (highlightItem) =>
    translatedDescription &&
    translatedDescription.includes(highlightItem.string);

  if (Array.isArray(props.highlights)) {
    for (const item in props.highlights) {
      if (insideHighlightRange(item)) {
        if (includeHighlights(item)) {
          translatedDescription = translatedDescription.replace(
            item.string,
            `<b>${item.string}</b>`
          );
        }
      } else {
        if (includeHighlights(item)) {
          translatedDescription = translatedDescription.replace(
            item.string,
            item.string
          );
        }
      }
    }
  }

  return <>{parse(translatedDescription)}</>;
}

Text.propTypes = {
  /**
   * Description to be displayed.
   */
  description: PropTypes.string.isRequired,
  /**
   * Percentage value specifying current scroll percentage
   */
  percentage: PropTypes.number.isRequired,
  /**
   * List of strings that need to be highlighed in current description
   */
  highlights: PropTypes.arrayOf(
    PropTypes.shape({
      string: PropTypes.string,
      minRange: PropTypes.number,
      maxRange: PropTypes.number,
    })
  ).isRequired,
};

Text.defaultProps = {
  description: "",
  percentage: 0,
  highlights: [],
};
